import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/customer';

export type Invoices = Awaited<ReturnType<(typeof service)['getInvoices']>>;

export function getInvoicesOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Invoices>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['customers', 'invoices', guid, [search]],
    queryFn: async () => await service.getInvoices(guid, search),
    initialData,
  });
}
